import paths from "../paths";

export default class ResidentialErPService {
    constructor(http) {
        this._http = http;
    }

    async getErPKit(name) {
        let response = await this._http.request({
            method: "get",
            url: `${paths.RVU_PATH}/${encodeURIComponent(name)}`
        });

        return response.data;
    }

    async getCurveTest(id) {
        let response = await this._http.request({
            method: "get",
            url: `${paths.RVU_PATH}/curve/test/${id}`
        });

        return response.data;
    }

    async evaluateResidentialErPPerformance({ name, parameters }) {
        let response = await this._http.request({
            method: "post",
            url: `${paths.RVU_PATH}/performance/${encodeURIComponent(name)}`,
            data: parameters
        });

        return response.data;
    }

    async storeErPKit({ name, inputs }) {
        await this._http.request({
            method: "post",
            url: `${paths.RVU_PATH}/${encodeURIComponent(name)}`,
            data: inputs
        });
    }
}